import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../Common/Table/Table';
import { RootState } from '../../../../../redux/root';
import { Pagination, TableWrapper, commonFilterMeta, commonHeaders } from '../../Common/Table/types';
import { setActiveProjects, setSelectedPermit } from '../../../../../redux/slices/projectSlice';
import PaginationMobile from '../../../../../pages/Responsive/PaginationMobile';
import { setRowsCount } from '../../../../../redux/slices/paginationSlice';
import { ProjectPermit } from '../../../types';
import { filterActiveRecords, updatePagination } from '../../../utils';
import useFilterActions from '../../../../../pages/Responsive/useFilterActions';
import useStatusFilter from '../../../hooks/useStatusFilter';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';

type Props = {
  showActiveOnly: boolean;
};
const projectsTable: FC<Props> = ({ showActiveOnly }) => {
  const allProjects = useSelector((state: RootState) => state.projectsSlice.projects);
  const projectsCollection = useSelector((state: RootState) => state.projectsSlice.activeProjects);
  const projectsLoading = useSelector((state: RootState) => state.projectsSlice.projectsLoading);

  const filteredRows = useFilterActions(projectsCollection);
  const { filteredRows: statusFilteredRows, withStatusFilter } = useStatusFilter(filteredRows);
  const dispatch = useDispatch();
  const [visibleProjects, setVisibleProjects] = useState(projectsCollection);
  const { pageSize, pageIndex } = useSelector((state: RootState) => state.pagination);

  useEffect(() => {
    const sortedRows = [...statusFilteredRows].sort((a: any, b: any) => {
      const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
      return bTime - aTime;
    });
    const _projects = updatePagination(pageIndex, pageSize, sortedRows);

    dispatch(setRowsCount(sortedRows.length));
    setVisibleProjects(_projects);
  }, [pageIndex, pageSize, projectsCollection, statusFilteredRows]);

  useEffect(() => {
    const _activeProjects = filterActiveRecords(allProjects, showActiveOnly);
    dispatch(setActiveProjects(_activeProjects));
  }, [showActiveOnly, allProjects]);

  const setSelectedItemInSlice = (project: ProjectPermit) => {
    dispatch(setSelectedPermit(project));
    dispatch(setShowDrawerContent(true));
  };
  return (
    <TableWrapper>
      <Table
        collection={visibleProjects}
        headers={withStatusFilter(commonHeaders)}
        filterMeta={commonFilterMeta}
        gridTemplateCols="1fr 1fr 195px 75px"
        setSelectedItemInSlice={setSelectedItemInSlice}
        isLoading={projectsLoading}
      />
      <Pagination>
        <PaginationMobile showEverywhere />
      </Pagination>
    </TableWrapper>
  );
};

export default projectsTable;
